import script from "./TechnicianRanking.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicianRanking.vue?vue&type=script&setup=true&lang=js"

import "./TechnicianRanking.vue?vue&type=style&index=0&id=17097856&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17097856"]])

export default __exports__